<template>
    <div
        v-if="$isMobile()"
        class="mobile-world-head justify-center"
        :style="{
            backgroundColor: serie.background_color,
            backgroundImage:
                'url(https://assets.pinguinitos.com/storage/30k7idz0of8kg8kgko.png.webp)',
            backgroundSize: '150%'
        }"
        :key="'ser-' + serie.id"
    >
        <app-image
            :url="serie.more.fondo_serie"
            :key="serie.more.fondo_serie"
            class="mt-20 z-10 relative"
        ></app-image>

        <slot></slot>

        <serie-main-info
            :serie="serie"
            class="container pl-5 pr-5"
        ></serie-main-info>
    </div>

    <div
        v-else
        class="serie-banner flex justify-center bg-cover bg-center bg-no-repeat pb-24 md:pb-32"
        :class="{ gradient: withGradient }"
        :style="{
            backgroundImage: `url('${background}')`
        }"
    >
        <serie-main-info :serie="serie" class="container"> </serie-main-info>

        <div
            class="absolute w-full bottom-0 sm:px-8 z-10"
            :style="{
                bottom: '-70px'
            }"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
import SerieMainInfo from "./SerieMainInfo";

export default {
    name: "serie-banner",

    components: { SerieMainInfo },

    props: {
        serie: {
            type: Object,
            required: true
        }
    },

    computed: {
        background() {
            return this.serie.img_tv;
        },

        withGradient() {
            return !this.serie.img_tv;
        }
    }
};
</script>

<style lang="scss" scoped>
.serie-banner {
    min-height: 370px;

    .serie-main-info {
        padding-top: 120px;
        z-index: 2;
    }
}
.gradient::before {
    content: "";
    background-image: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0.5)
    );
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    pointer-events: none;
}
</style>
